import {Button} from "../Button";
import React from "react";

export default function OkBtnPopupContext(props) {

    return (<>{
        props.okBtn
        ? (<Button
            name="OK" onClick={(e) => props.handlePopup({type: "ok"})}
            variant="round"
            bWidth="small"
            styling="plain"
            className='mx-3'>
            {props.okBtn}
        </Button>)
        : null
    }</>)
}